var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32631)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#00EAAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.95 5.38208L12.9488 6.94021C13.2682 7.56623 13.4333 8.25958 13.4303 8.96239C13.4303 11.4374 11.4278 13.4303 8.96233 13.4303C8.26274 13.4335 7.57264 13.2684 6.95027 12.9488L5.38202 13.9596C6.39283 14.6774 7.62077 15.1122 8.95277 15.1122C12.3441 15.1122 15.1026 12.3633 15.1026 8.96239C15.1026 7.62083 14.6773 6.39289 13.95 5.38208Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.96229 12.0318C9.68262 12.0318 10.3802 11.7796 10.934 11.319C11.4878 10.8584 11.8629 10.2184 11.9942 9.51016C11.0326 9.30085 10.0378 9.29615 9.07437 9.49636C8.1109 9.69657 7.20033 10.0972 6.40179 10.6723C6.68352 11.0924 7.06467 11.4364 7.51137 11.6736C7.95808 11.9109 8.45648 12.0342 8.96229 12.0324V12.0318Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4738 8.79189C11.0121 8.79189 11.5313 8.8487 12.042 8.96233C12.0417 8.1431 11.7161 7.35751 11.1369 6.77823C10.5576 6.19895 9.77198 5.87338 8.95275 5.87308C8.51252 5.87343 8.07748 5.96808 7.67689 6.15065C7.2763 6.33322 6.91947 6.59948 6.6304 6.9315C6.34133 7.26353 6.12673 7.65362 6.00104 8.07553C5.87536 8.49743 5.8415 8.94137 5.90175 9.37745C5.12719 9.97314 4.75875 10.4361 4.73963 10.4546C4.57259 9.97806 4.48647 9.47689 4.48482 8.97189C4.48482 6.49689 6.48732 4.50339 8.95275 4.50339C9.68007 4.50339 10.3601 4.67327 10.9648 4.98545L12.5235 3.97464C11.491 3.21683 10.243 2.80956 8.96232 2.81252C8.1545 2.81178 7.35447 2.97034 6.60801 3.27914C5.86155 3.58793 5.1833 4.04089 4.61209 4.6121C4.04088 5.18331 3.58792 5.86156 3.27912 6.60802C2.97033 7.35449 2.81176 8.15452 2.8125 8.96233C2.8125 10.332 3.25688 11.5886 4.01232 12.6085C4.30481 12.0797 4.65469 11.5976 5.06081 11.1628C5.06081 11.1628 5.6655 10.5306 6.12844 10.2094C7.38896 9.28618 8.91132 8.78957 10.4738 8.79189Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32631"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZen);
export default __webpack_public_path__ + "static/media/zen.937d0ccd27d1b601004bf54fc9e2f853.svg";
export { ForwardRef as ReactComponent };